import { Component, OnInit } from '@angular/core';
import { ApplicationFilesService } from '../../shared/services/application-files.service';

@Component({
  selector: 'ins-forms',
  templateUrl: './forms.component.html',
})
export class FormsComponent implements OnInit {
  claimForms: string[] = [];

  constructor(private appFilesService: ApplicationFilesService) {}

  ngOnInit(): void {
    this.appFilesService.getFilesForDownload('Claim Forms').subscribe({
      next: (files) => (this.claimForms = files),
      error: () => (this.claimForms = []),
    });
  }

  downloadForm(fileName: string): void {
    this.appFilesService.downloadFile(`Claim Forms\\${fileName}`);
  }

  getDisplayName(fileName: string): string {
    return fileName.replace('.pdf', '');
  }
}
